import { useEffect, useState } from "react";
//components
import Input from "../../../../input/Input";
import MaskInput from "../../../../input/MaskInput";
import CardProfile from "../../../../upload/CardProfile";
import TextareaInput from "../../../../input/TextareaInput";
//services
import { getCheckCnpj } from "../../../../../services/GeneralRegistration/getCheckCnpj";
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from "primereact/tooltip";
import { Contacts } from "./Contacts";

export const CnpjInputs = ({
  file,
  errors,
  control,
  setFile,
  setValue,
  contacts,
  getValues,
  setAddress,
  telephones,
  setTelephones,
  inputRequireds,
  cumulativeTooltip,
  setCumulativeTooltip,
}) => {
  useEffect(() => {
    if (getValues) {
      Object.keys(getValues).forEach((key) => {
        setValue(key, getValues[key]);
      });
    }
  }, [getValues, setValue]);

  const handleCheckCnpj = async (event) => {
    const doc = event.replace(/\//g, "");
    try {
      const response = await getCheckCnpj(doc);
      if (response) {
        setValue("name", response.name);
        setAddress({
          cep: response.cep,
          num: response.num,
          complement: response.complement,
          city: response.city,
          state: response.state,
          address: response.address,
          neighborhood: response.neighborhood,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-2 my-auto col-profile-pic">
          <CardProfile
            name="profile_photo"
            control={control}
            setValue={setValue}
            preValue={file && file}
            onPhotoUpload={(data) => setFile(data.setFile)}
          />
        </div>
        <div className="col-xl-10">
          <div className="row">
            <Input
              name="type_doc"
              control={control}
              errors={errors}
              type="hidden"
              value="2"
            />
            <div className="col-xl-3 col-md-6 mt-4">
              <MaskInput
                name="doc"
                control={control}
                errors={errors}
                onComplete={(e) => handleCheckCnpj(e)}
                isRequired={true}
                label="CNPJ *"
                mask="99.999.999/9999-99"
              />
            </div>
            <div className="col-xl-3 col-md-6 mt-4">
              <Input
                name="name"
                control={control}
                errors={errors}
                isRequired={true}
                label="Razão Social *"
                // placeholder="Digite a Razão Social"
              />
            </div>

            <div className="col-xl-3 col-md-6 mt-4">
              <Input
                name="state_registration"
                control={control}
                errors={errors}
                isRequired={inputRequireds?.includes("state_registration")}
                // placeholder="Digite a inscrição estadual"
                label={`Inscrição Estadual ${
                  inputRequireds?.includes("state_registration") ? "*" : ""
                }`}
              />
            </div>
            <div className="col-xl-3 col-md-6 mt-4">
              <Input
                name="municipal_registration"
                control={control}
                errors={errors}
                isRequired={inputRequireds?.includes("municipal_registration")}
                // placeholder="Digite a inscrição municipal"
                label={`Inscrição Municipal ${
                  inputRequireds?.includes("municipal_registration") ? "*" : ""
                }`}
              />
            </div>
            {/* <div className="col-md-6">
              <MultipleSelect
                name="partners"
                control={control}
                label="Sócios Vinculados"
                options={partners}
                emptyMessage="Cadastre sócios para vinculá-los aqui"
                // placeholder="Sócios"
              />
            </div> */}
            {/* <div className="col-md-12">
              <Contact
                control={control}
                errors={errors}
                contacts={contacts}
                form={form}
              />
            </div> */}
            <div className="col-md-12 pt-4">
              <TextareaInput
                name="obs"
                max={255}
                errors={errors}
                control={control}
                isRequired={inputRequireds?.includes("obs")}
                label={`Observação ${
                  inputRequireds?.includes("obs") ? "*" : ""
                }`}
              />
            </div>
            <div className="row">
              <div className="col-xl-7">
                <Contacts
                  control={control}
                  errors={errors}
                  contacts={contacts}
                  setValue={setValue}
                  getValues={getValues}
                  telephones={telephones}
                  inputRequireds={inputRequireds}
                  setTelephones={setTelephones}
                />
              </div>
              <div className="col-xl-5">
                <div className="pt-4">
                  <RadioButton
                    inputId="ingredient1"
                    name="cod_inc_trib"
                    value={2}
                    checked={cumulativeTooltip === 2}
                    onChange={(e) => setCumulativeTooltip(e.value)}
                  />
                  <label htmlFor="ingredient1" className="mx-2">
                    Regime Cumulativo
                    <i
                      className="custom-target-icon px-2 pi pi-info-circle p-text-secondary"
                      data-pr-tooltip="No regime cumulativo, PIS (0,65%) e COFINS (3%) incidem sobre a receita bruta sem direito a créditos fiscais. As alíquotas são menores que no regime não-cumulativo, mas o valor é calculado de forma integral, sem deduções."
                      style={{ cursor: "pointer" }}
                    ></i>
                  </label>
                </div>
                <div className="pt-4">
                  <RadioButton
                    inputId="ingredient1"
                    name="cod_inc_trib"
                    value={1}
                    checked={cumulativeTooltip === 1}
                    onChange={(e) => setCumulativeTooltip(e.value)}
                  />
                  <label htmlFor="ingredient1" className="mx-2">
                    Regime Não-cumulativo
                    <Tooltip target=".custom-target-icon" />
                    <i
                      className="custom-target-icon px-2 pi 
      pi-info-circle p-text-secondary"
                      data-pr-tooltip="No regime não-cumulativo, PIS (1,65%) e COFINS (7,6%) incidem sobre a receita bruta, mas permitem o abatimento de créditos fiscais. Isso difere do regime cumulativo, que possui alíquotas menores, mas sem direito a créditos."
                      style={{ cursor: "pointer" }}
                    ></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
